module.exports = __webpack_public_path__ + "static/media/29BDOS17.a3c6f042.jpg";